import React from "react"

function IconIndustryLaw() {
    return (
      <div className="iconContainer" style={{ marginLeft: '-9px'}}>
        <svg width="64" height="68" viewBox="0 0 64 68" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_d)">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M48 8L54 16C51.28 20.96 48.82 27 52 31.56C53.7843 34.0211 54.3976 37.1416 53.6776 40.0949C52.9576 43.0482 50.9768 45.5363 48.26 46.9L32 54L15.82 46.9C13.09 45.5513 11.0916 43.0698 10.3558 40.1151C9.61995 37.1603 10.2213 34.0315 12 31.56C15.18 27 12.72 20.96 10 16L16 8C18.0168 9.03107 20.2552 9.55291 22.52 9.52C26.0164 9.61711 29.4143 8.35543 32 6C34.5857 8.35543 37.9836 9.61711 41.48 9.52C43.7448 9.55291 45.9832 9.03107 48 8ZM38.22 32.12L42.62 27.56C42.9595 27.223 43.0902 26.7288 42.9615 26.2681C42.8328 25.8073 42.465 25.4523 42 25.34L35.74 24.42L33.14 18.86C32.9279 18.3694 32.4445 18.0517 31.91 18.0517C31.3755 18.0517 30.8921 18.3694 30.68 18.86L28.1 24.42L22 25.36C21.5083 25.4496 21.1115 25.8131 20.9793 26.295C20.8471 26.777 21.0028 27.2921 21.38 27.62L25.78 32.18L24.8 38.3C24.6702 38.8307 24.8657 39.3879 25.2986 39.7212C25.7314 40.0545 26.3201 40.1011 26.8 39.84L32 36.94L37.22 39.78C37.7007 40.0224 38.2779 39.9677 38.7045 39.6392C39.1311 39.3107 39.3315 38.7667 39.22 38.24L38.22 32.12Z" fill="url(#paint0_linear)"/>
        </g>
        <defs>
        <filter id="filter0_d" x="0" y="0" width="64" height="68" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
        <feOffset dy="4"/>
        <feGaussianBlur stdDeviation="5"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0844351 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
        </filter>
        <linearGradient id="paint0_linear" x1="10" y1="6" x2="10" y2="54" gradientUnits="userSpaceOnUse">
        <stop stop-color="white"/>
        <stop offset="1" stop-color="white" stop-opacity="0.522509"/>
        </linearGradient>
        </defs>
        </svg>
      </div>
    )
  }

function IconIndustryEMS() {
  return (
    <div className="iconContainer" style={{ marginLeft: '-9px', marginBottom: '-4px'}}>
    <svg width="68px" height="64px" viewBox="0 0 68 64" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
        <title>EMS</title>
        <defs>
            <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="linearGradient-1">
                <stop stopColor="#FFFFFF" offset="0%"></stop>
                <stop stopColor="#FFFFFF" stopOpacity="0.522508741" offset="100%"></stop>
            </linearGradient>
            <path d="M51.4780845,32.0001 L44.8531845,32.0001 C44.4744998,32.0001129 44.1283081,32.2140294 43.9588845,32.5527 L40.7888845,38.8915 C40.4501584,39.5692282 39.757546,39.9973641 38.9998845,39.9973641 C38.2422231,39.9973641 37.5496107,39.5692282 37.2108845,38.8915 L29.0006845,22.4765 L25.6194845,29.2365 C24.7725662,30.9300622 23.041506,31.999785 21.1479845,31.9997 L16.5228845,31.9997 C15.9707797,31.9984878 15.4625841,32.3004871 15.1997201,32.786001 C14.9368562,33.2715149 14.961769,33.8621465 15.2645845,34.3238 C21.4762845,43.5718 31.3062845,50 34.0006845,50 C36.6950845,50 46.5248845,43.5718 52.7367845,34.3242 C53.0395664,33.8624739 53.0644056,33.2717932 52.8014569,32.7862772 C52.5385082,32.3007612 52.0302314,31.9988086 51.4780845,32.0001 Z M45.4542845,6 C40.4400333,6.04364699 35.9344789,9.07204075 34.0006845,13.6986 C32.0668992,9.07174997 27.5610031,6.04324592 22.5464845,6 C15.500462,6.12059945 9.8851501,11.9282107 10.0017845,18.9743 C10.0211145,21.5856048 10.4767584,24.1753154 11.3498845,26.6364 C11.6275952,27.4505312 12.3911961,27.9988461 13.2513845,28.0018 L21.1475845,28.0018 C21.5262693,28.0017871 21.872461,27.7878706 22.0418845,27.4492 L27.2117845,17.1124 C27.5505504,16.4347818 28.2431037,16.0067359 29.0006845,16.0067359 C29.7582654,16.0067359 30.4508186,16.4347818 30.7895845,17.1124 L38.9995845,33.5275 L40.3810845,30.7653 C41.2281186,29.0718303 42.959094,28.0021211 44.8525845,28.002 L54.7491845,28.002 C55.6094451,27.9990775 56.3730936,27.4506482 56.6506845,26.6364 C57.5238107,24.1753154 57.9794545,21.5856048 57.9987845,18.9743 C58.1154196,11.9282875 52.5002284,6.12070852 45.4542845,6 L45.4542845,6 Z" id="path-2"></path>
            <filter x="-35.4%" y="-29.5%" width="170.8%" height="177.3%" filterUnits="objectBoundingBox" id="filter-3">
                <feOffset dx="0" dy="4" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
                <feGaussianBlur stdDeviation="5" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
                <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.0844350962 0" type="matrix" in="shadowBlurOuter1"></feColorMatrix>
            </filter>
        </defs>
        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="EMS" fillRule="nonzero">
                <use fill="black" fillOpacity="1" filter="url(#filter-3)" xlinkHref="#path-2"></use>
                <use fill="url(#linearGradient-1)" xlinkHref="#path-2"></use>
            </g>
        </g>
    </svg>
    </div>
  )
  }

function IconIndustryFire(props) {
  return (
    <div className="iconContainer" style={{ marginLeft: '-9px'}}>
      <svg
        width={61}
        height={71}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <g filter="url(#prefix__filter0_d)">
          <path
            d="M36.257 54.631a15.561 15.561 0 004.723-7 .515.515 0 00-.488-.667c-2.3.043-4.584.37-6.802.973a.517.517 0 01-.664-.68A19.951 19.951 0 0034 39.981c0-5.3-3.219-9.404-4.352-10.813a.495.495 0 00-.859.15C27.28 34.137 21 41.049 21 47.976c0 4.164 2.765 5.971 2.969 6.937.168.795-.237 1.236-.998.996C17.907 54.315 10 47.03 10 37.982 10 21.542 26 18.262 26 10a7.513 7.513 0 00-.952-3.002.762.762 0 01.93-.97C31.121 7.413 43 14.595 43 28.988a24.617 24.617 0 01-2 8.994s3.362-.584 7.92-1.003a1.052 1.052 0 011.078 1.172c0 6.94-5.423 14.941-13.137 17.824-.7.261-1.168-.836-.604-1.344z"
            fill="url(#prefix__paint0_linear)"
          />
        </g>
        <defs>
          <linearGradient
            id="prefix__paint0_linear"
            x1={10}
            y1={6}
            x2={10}
            y2={56.015}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#fff" />
            <stop offset={1} stopColor="#fff" stopOpacity={0.523} />
          </linearGradient>
          <filter
            id="prefix__filter0_d"
            x={0}
            y={0}
            width={60.005}
            height={70.015}
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity={0} result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            />
            <feOffset dy={4} />
            <feGaussianBlur stdDeviation={5} />
            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0844351 0" />
            <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
            <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          </filter>
        </defs>
      </svg>
    </div>
  );
}


function IconIndustry911() {
  return (
    <div className="iconContainer" style={{ marginLeft: '-9px' }}>
    <svg height="68" viewBox="0 0 68 68" width="68" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"><defs><linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%"><stop offset="0" stopColor="#fff"/><stop offset="1" stopColor="#fff" stopOpacity=".522509"/></linearGradient><path id="b" d="m56.008501 32c-1.1045695 0-2-.8954305-2-2-.0125647-11.0404863-8.9595136-19.9874353-20-20-1.1045695 0-2-.8954305-2-2s.8954305-2 2-2c13.2485289.01520959 23.9847904 10.7514711 24 24 0 1.1045695-.8954305 2-2 2zm-14-2c-.004905-4.4165599-3.5840401-7.9956502-8.0006-8.0005-1.1045695 0-2-.8954305-2-2s.8954305-2 2-2c6.6248662.0070542 11.9937146 5.3756342 12.0011 12.0005 0 1.1045695-.8954305 2-2 2s-2-.8954305-2-2zm-15.2112 7.2048c2.5152598 2.5938019 5.5983149 4.5682935 9.0064 5.768.3476058.1295138.7388443.0434413 1-.22l4.0044-4.0048c.5572965-.5526453 1.3960839-.7078102 2.1142-.3911l7.9035 3.4124c.9198818.3967574 1.3889178 1.4264741 1.0845 2.3809l-2.7911 8.5506c-.2552664.7911715-1.0002962 1.3203892-1.8314 1.3009-3.6077-.0739-13.6279-1.3859-24.7645-12.5229-11.1385-11.1379-12.4492-21.1598-12.5228-24.7663-.01910834-.8306355.5100303-1.5750418 1.3008-1.83l8.5482-2.79c.9550448-.3049019 1.9856673.1640504 2.3832 1.0844l3.4128 7.905c.3162554.7171583.1611589 1.5548148-.3909 2.1112l-4.0063 4.0059c-.2626169.2607308-.348286.6510532-.219.9978 1.1993044 3.4087471 3.1738345 6.49241 5.768 9.008z"/><filter id="c" height="170.8%" width="170.8%" x="-35.4%" y="-27.1%"><feOffset dx="0" dy="4" in="SourceAlpha" result="shadowOffsetOuter1"/><feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="5"/><feColorMatrix in="shadowBlurOuter1" type="matrix" values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.0844350962 0"/></filter></defs><g fill="none"><use fill="#000" filter="url(#c)" xlinkHref="#b"/><use fill="url(#a)" xlinkHref="#b"/></g></svg>
    </div>
  )
}

function IconResponseAutomate() {
  return (
    <svg version="1.1" viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg">
    <title>Icon1</title>
    <g fill="none" fillRule="evenodd">
    <g transform="translate(-102 -326)" fill="#5476EB">
    <g transform="translate(102 326)">
    <path id="background" d="m13.959 1.2497e-15 28.082 1.1342e-15c4.8538-3.769e-15 6.6139 0.50538 8.3884 1.4544 1.7745 0.94901 3.1671 2.3416 4.1161 4.1161 0.94901 1.7745 1.4544 3.5346 1.4544 8.3884v28.082c0 4.8538-0.50538 6.6139-1.4544 8.3884-0.94901 1.7745-2.3416 3.1671-4.1161 4.1161-1.7745 0.94901-3.5346 1.4544-8.3884 1.4544h-28.082c-4.8538 0-6.6139-0.50538-8.3884-1.4544-1.7745-0.94901-3.1671-2.3416-4.1161-4.1161-0.94901-1.7745-1.4544-3.5346-1.4544-8.3884l-1.9686e-15 -28.082c8.3931e-16 -4.8538 0.50538-6.6139 1.4544-8.3884 0.94901-1.7745 2.3416-3.1671 4.1161-4.1161 1.7745-0.94901 3.5346-1.4544 8.3884-1.4544z" opacity=".16"/>
    <path id="glyph" d="m28 20.222c-4.0911 0-7.42 2.0689-7.7778 4.6667h15.556c-0.31111-2.5978-3.6244-4.6667-7.7778-4.6667zm0-1.5556c2.5773 0 4.6667-2.0893 4.6667-4.6667s-2.0893-4.6667-4.6667-4.6667-4.6667 2.0893-4.6667 4.6667 2.0893 4.6667 4.6667 4.6667zm4.6667 14c0 2.5773 2.0893 4.6667 4.6667 4.6667 2.5773 0 4.6667-2.0893 4.6667-4.6667 0-2.5773-2.0893-4.6667-4.6667-4.6667-2.5773 0-4.6667 2.0893-4.6667 4.6667zm-14 4.6667c2.5773 0 4.6667-2.0893 4.6667-4.6667 0-2.5773-2.0893-4.6667-4.6667-4.6667-2.5773 0-4.6667 2.0893-4.6667 4.6667 0 2.5773 2.0893 4.6667 4.6667 4.6667zm18.667 1.5556c-4.2933 0-7.7778 2.2711-7.7778 5.04v2.7378h15.556v-2.7378c0-2.7689-3.4844-5.04-7.7778-5.04zm-18.667 0c-4.2933 0-7.7778 2.2711-7.7778 5.04v2.7378h15.556v-2.7378c0-2.7689-3.4844-5.04-7.7778-5.04z"/>
    </g>
    </g>
    </g>
    </svg>
  )
  }

function IconResponseChat() {
  return (
    <svg version="1.1" viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg">
    <title>Icon2</title>
    <g fill="none" fillRule="evenodd">
    <g transform="translate(-111 -409)" fill="#5476EB">
    <g transform="translate(111 409)">
    <path id="background" d="m13.959 1.2497e-15 28.082 1.1342e-15c4.8538-3.769e-15 6.6139 0.50538 8.3884 1.4544 1.7745 0.94901 3.1671 2.3416 4.1161 4.1161 0.94901 1.7745 1.4544 3.5346 1.4544 8.3884v28.082c0 4.8538-0.50538 6.6139-1.4544 8.3884-0.94901 1.7745-2.3416 3.1671-4.1161 4.1161-1.7745 0.94901-3.5346 1.4544-8.3884 1.4544h-28.082c-4.8538 0-6.6139-0.50538-8.3884-1.4544-1.7745-0.94901-3.1671-2.3416-4.1161-4.1161-0.94901-1.7745-1.4544-3.5346-1.4544-8.3884l-1.9686e-15 -28.082c8.3931e-16 -4.8538 0.50538-6.6139 1.4544-8.3884 0.94901-1.7745 2.3416-3.1671 4.1161-4.1161 1.7745-0.94901 3.5346-1.4544 8.3884-1.4544z" opacity=".16"/>
    <path id="glyph" d="m34.222 28c-0.85911 0-1.5556-0.69645-1.5556-1.5556 0-0.85911 0.69645-1.5556 1.5556-1.5556s1.5556 0.69645 1.5556 1.5556c0 0.85911-0.69645 1.5556-1.5556 1.5556m-6.2222 0c-0.85911 0-1.5556-0.69645-1.5556-1.5556 0-0.85911 0.69645-1.5556 1.5556-1.5556s1.5556 0.69645 1.5556 1.5556c0 0.85911-0.69645 1.5556-1.5556 1.5556m-6.2222 0c-0.85911 0-1.5556-0.69645-1.5556-1.5556 0-0.85911 0.69645-1.5556 1.5556-1.5556s1.5556 0.69645 1.5556 1.5556c0 0.85911-0.69645 1.5556-1.5556 1.5556m6.2222-18.667c-10.293 0-18.667 7.6767-18.667 17.111 0 4.6713 2.0658 8.8993 5.3884 11.989 0.378 0.35156 0.60044 0.854 0.51178 1.3611-0.30644 1.7842-1.1449 3.6307-2.5387 5.4989l-0.10111 0.13689c-0.17039 0.23704-0.19435 0.54932-0.062094 0.80957 0.13225 0.26025 0.39862 0.425 0.69054 0.4271 3.9402 0 6.6127-1.4747 8.4358-3.3258 0.38889-0.39667 0.96911-0.50867 1.5073-0.37644 1.5431 0.38267 3.1624 0.59111 4.8347 0.59111 10.293 0 18.667-7.6767 18.667-17.111 0-9.4344-8.3736-17.111-18.667-17.111"/>
    </g>
    </g>
    </g>
    </svg>
  )
}

function IconResponseSurveys() {
  return (
    <svg version="1.1" viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg">
    <title>Icon3</title>
    <g fill="none" fillRule="evenodd">
    <g transform="translate(-211 -484)" fill="#5476EB">
    <g transform="translate(211 484)">
    <path id="background" d="m13.959 1.2497e-15 28.082 1.1342e-15c4.8538-3.769e-15 6.6139 0.50538 8.3884 1.4544 1.7745 0.94901 3.1671 2.3416 4.1161 4.1161 0.94901 1.7745 1.4544 3.5346 1.4544 8.3884v28.082c0 4.8538-0.50538 6.6139-1.4544 8.3884-0.94901 1.7745-2.3416 3.1671-4.1161 4.1161-1.7745 0.94901-3.5346 1.4544-8.3884 1.4544h-28.082c-4.8538 0-6.6139-0.50538-8.3884-1.4544-1.7745-0.94901-3.1671-2.3416-4.1161-4.1161-0.94901-1.7745-1.4544-3.5346-1.4544-8.3884l-1.9686e-15 -28.082c8.3931e-16 -4.8538 0.50538-6.6139 1.4544-8.3884 0.94901-1.7745 2.3416-3.1671 4.1161-4.1161 1.7745-0.94901 3.5346-1.4544 8.3884-1.4544z" opacity=".16"/>
    <path id="glyph" d="m38.889 10.889h-21.778c-3.4364 0-6.2222 2.7858-6.2222 6.2222v21.778c0 3.4364 2.7858 6.2222 6.2222 6.2222h21.778c3.4364 0 6.2222-2.7858 6.2222-6.2222v-21.778c0-3.4364-2.7858-6.2222-6.2222-6.2222zm-23.333 6.7511c0-1.1512 0.93324-2.0844 2.0844-2.0844h8.2756c1.1512 0 2.0844 0.93324 2.0844 2.0844v2.0533c0 1.1512-0.93324 2.0844-2.0844 2.0844h-8.2756c-1.1512 0-2.0844-0.93324-2.0844-2.0844v-2.0533zm18.667 20.72c0.0040874 0.55139-0.21205 1.0816-0.60049 1.473s-0.91704 0.61145-1.4685 0.61145h-14.513c-1.1512 0-2.0844-0.93324-2.0844-2.0844v-2.0533c0-1.1512 0.93324-2.0844 2.0844-2.0844h14.513c0.55141 0 1.08 0.22009 1.4685 0.61145s0.60458 0.9216 0.60049 1.473v2.0533zm6.2222-9.3333c0.0040874 0.55139-0.21205 1.0816-0.60049 1.473-0.38844 0.39136-0.91704 0.61145-1.4685 0.61145h-20.736c-1.1512 0-2.0844-0.93324-2.0844-2.0844v-2.0533c0-1.1512 0.93324-2.0844 2.0844-2.0844h20.736c0.55141 0 1.08 0.22009 1.4685 0.61145 0.38844 0.39136 0.60458 0.9216 0.60049 1.473v2.0533z"/>
    </g>
    </g>
    </g>
    </svg>
  )
  }

function IconResponseMeasure() {
  return (
    <svg version="1.1" viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg">
    <title>Icon4</title>
    <g fill="none" fillRule="evenodd">
    <g transform="translate(-239 -559)" fill="#5476EB">
    <g transform="translate(239 559)">
    <path id="background" d="m13.959 1.2497e-15 28.082 1.1342e-15c4.8538-3.769e-15 6.6139 0.50538 8.3884 1.4544 1.7745 0.94901 3.1671 2.3416 4.1161 4.1161 0.94901 1.7745 1.4544 3.5346 1.4544 8.3884v28.082c0 4.8538-0.50538 6.6139-1.4544 8.3884-0.94901 1.7745-2.3416 3.1671-4.1161 4.1161-1.7745 0.94901-3.5346 1.4544-8.3884 1.4544h-28.082c-4.8538 0-6.6139-0.50538-8.3884-1.4544-1.7745-0.94901-3.1671-2.3416-4.1161-4.1161-0.94901-1.7745-1.4544-3.5346-1.4544-8.3884l-1.9686e-15 -28.082c8.3931e-16 -4.8538 0.50538-6.6139 1.4544-8.3884 0.94901-1.7745 2.3416-3.1671 4.1161-4.1161 1.7745-0.94901 3.5346-1.4544 8.3884-1.4544z" opacity=".16"/>
    <path id="glyph" d="m28 9.3333c-10.309 0-18.667 8.3574-18.667 18.667s8.3574 18.667 18.667 18.667 18.667-8.3574 18.667-18.667c0-4.9507-1.9667-9.6986-5.4673-13.199-3.5007-3.5007-8.2486-5.4673-13.199-5.4673zm0 3.1111c0.85911 0 1.5556 0.69645 1.5556 1.5556s-0.69645 1.5556-1.5556 1.5556-1.5556-0.69645-1.5556-1.5556 0.69645-1.5556 1.5556-1.5556zm-13.284 20.222h-0.35778c-0.74147 0.018122-1.3926-0.48976-1.5556-1.2133-0.1926-0.83698 0.32957-1.6717 1.1665-1.8646s1.6718 0.32887 1.8651 1.1657c0.1933 0.83682-0.32818 1.672-1.1649 1.8656l0.046667 0.046667zm3.5311-12.444c-0.29995 0.36983-0.75276 0.5819-1.2289 0.57556-0.34808-0.0033365-0.68599-0.11779-0.96444-0.32667-0.32508-0.25701-0.53418-0.63311-0.5809-1.0449-0.046725-0.41176 0.072782-0.82515 0.33201-1.1485 0.53694-0.6744 1.5189-0.78583 2.1933-0.24889 0.6744 0.53694 0.78583 1.5189 0.24889 2.1933zm7 15.913c-1.3115-1.3003-1.5277-3.3436-0.51722-4.8895s2.9688-2.1678 4.6861-1.4883l4.6667-4.6667c0.61718-0.52854 1.5372-0.49301 2.1118 0.081568 0.57457 0.57457 0.61011 1.4946 0.081568 2.1118l-4.6667 4.6667c0.67956 1.7173 0.057588 3.6756-1.4883 4.6861-1.5459 1.0105-3.5892 0.79433-4.8895-0.51722l0.015556 0.015556zm13.642-15.322c-0.45685-0.01604-0.88352-0.23222-1.1667-0.59111-0.25923-0.32331-0.37874-0.7367-0.33201-1.1485 0.046725-0.41176 0.25582-0.78786 0.5809-1.0449 0.43626-0.34734 1.0247-0.43556 1.5436-0.23141s0.88955 0.66963 0.97222 1.2211-0.13514 1.1052-0.5714 1.4525c-0.29398 0.22633-0.65569 0.3469-1.0267 0.34222zm2.7689 11.853h-0.34222c-0.40525-0.089104-0.75811-0.33642-0.98012-0.68696-0.22201-0.35054-0.29477-0.77525-0.2021-1.1797 0.074706-0.41671 0.31603-0.78497 0.66828-1.0198s0.785-0.31595 1.1984-0.22464c0.55575 0.061132 1.0367 0.41411 1.2616 0.92596 0.22493 0.51186 0.1597 1.1048-0.17111 1.5556s-0.87696 0.69072-1.4327 0.62959z"/>
    </g>
    </g>
    </g>
    </svg>
  )
  }

function IconLogo() {
  return (
    <svg version="1.1" viewBox="0 0 127 32" xmlns="http://www.w3.org/2000/svg">
    <title>logo</title>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(-243 -384)">
        <g transform="translate(243 384)">
          <path id="logoType" d="m46.989 25.378c3.861 0 6.939-1.809 8.478-5.157l-3.402-1.782c-0.999 2.133-2.808 3.186-4.995 3.186-3.348 0-5.67-2.565-5.67-6.075s2.322-6.075 5.67-6.075c2.187 0 3.969 1.053 4.968 3.186l3.429-1.782c-1.539-3.348-4.617-5.157-8.478-5.157-5.724-0.081-9.828 4.293-9.747 9.855-0.081 5.589 4.05 9.882 9.747 9.801zm16.875 0c3.969 0 6.318-2.187 6.318-5.67v-8.478h-3.834v7.992c0 1.809-0.837 2.7-2.484 2.7-1.674 0-2.511-0.891-2.511-2.7v-7.992h-3.834v8.478c0 3.483 2.376 5.67 6.345 5.67zm16.416 0c2.511 0 4.563-0.891 5.886-2.484l-2.187-2.268c-0.918 0.999-2.106 1.485-3.564 1.485-2.052 0-3.348-0.945-3.699-2.862h9.882c0.054-0.459 0.081-0.918 0.081-1.323 0-4.266-2.7-7.074-6.777-7.074-4.212 0-7.047 3.051-7.047 7.317 0 4.374 2.97 7.209 7.425 7.209zm2.592-8.613h-6.156c0.324-1.728 1.458-2.673 3.213-2.673s2.808 0.945 2.943 2.673zm10.935 8.235v-7.83h8.37v7.83h3.969v-18.9h-3.969v7.398h-8.37v-7.398h-3.996v18.9h3.996zm18.252-15.795c1.431 0 2.376-0.918 2.376-2.295s-0.945-2.295-2.376-2.295-2.376 0.918-2.376 2.295 0.945 2.295 2.376 2.295zm1.917 15.795v-13.77h-3.834v13.77h3.834zm9.7205 0.189c0.999 0 1.917-0.108 2.754-0.351v-3.267c-0.567 0.135-1.188 0.216-1.863 0.216-1.377 0-1.863-0.432-1.863-1.647v-5.562h3.672v-3.348h-3.672v-4.05h-3.834v4.05h-2.511v3.348h2.511v6.156c0 3.132 1.458 4.455 4.806 4.455z" fill="#0F1961" fillRule="nonzero"/>
          <path id="bounding" d="m16 0c8.8366 0 16 7.1634 16 16s-7.1634 16-16 16-16-7.1634-16-16 7.1634-16 16-16zm0 6c-5.5228 0-10 4.4772-10 10s4.4772 10 10 10 10-4.4772 10-10-4.4772-10-10-10z" fill="#5476EB" fillOpacity="0"/>
          <path id="logoMark1" d="m16 0c5.7215 0 10.742 3.0031 13.57 7.519l-5.0886 3.1805c-1.7677-2.8225-4.9053-4.6995-8.4813-4.6995-5.5228 0-10 4.4772-10 10s4.4772 10 10 10c3.576 0 6.7136-1.877 8.4813-4.6995l5.0886 3.1805c-2.8284 4.5159-7.8484 7.519-13.57 7.519-8.8366 0-16-7.1634-16-16s7.1634-16 16-16z" fill="#5476EB"/>
          <polyline id="logoMark2" points="8 16 11 16 13 21.5 13 10.5 14.5 16 17.5 16 19 21.5 19 10.5 21 16 24 16" stroke="#5476EB" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"/>
        </g>
      </g>
    </g>
    </svg>
  )
}

function IconFeatureCheck() {
  return (
    <svg height="13" viewBox="0 0 15 13" width="15" xmlns="http://www.w3.org/2000/svg"><path d="m14.6501156.15734508c-.3828769-.26514507-.9122747-.18761769-1.1983567.1754927l-8.14099203 10.53931202-3.79757405-4.28494694c-.30946639-.34444664-.84293361-.38859581-1.20752355-.09993334-.17356562.13573827-.28280923.33464373-.30247178.55072589s.0519585.430631.19830308.59403903l4.50008775 5.07791396c.16492367.184637.40388432.2904527.65501277.2900516l.02833389-.0008136c.26164005-.0067809.50596815-.1290218.66417962-.3322987l8.7860047-11.37452729c.1338701-.17313383.1897015-.39192915.1546457-.60603548s-.1579794-.40508247-.3404827-.52897985" fill="#fff"/></svg>
  )
}

function IconFeatureArrow() {
  return (
    <svg height="12" viewBox="0 0 16 12" width="16" xmlns="http://www.w3.org/2000/svg"><path d="m.40191782 5.02708906 4.88159277-4.81837027c.24407964-.23990641.62472765-.28189003.91457222-.079469.33415664.23315904.42350723.70322566.19758828 1.05034025l-2.23303813 3.42766281 11.13104854.63800111c.3936433.01282619.7063185.34587059.7063185.7523315 0 .4064609-.3126752.73950531-.7063185.7523315l-11.13104854.63800111 2.23303813 3.42766283c.2141645.3195557.15833976.75469-.12902607 1.0057127s-.71241697.2359481-.982408-.0348415l-4.8823192-4.81837025c-.25671276-.25331878-.40191782-.60394019-.40191782-.97049639 0-.36655621.14520506-.71717761.40191782-.9704964" fill="#fff"/></svg>
  )
}

function IconPlay(props) {
  return (
    <svg
      width={40}
      height={40}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter="url(#prefix__filter0_di)" clipPath="url(#prefix__clip0)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M37.8 17.299L10.822 3.786a3 3 0 00-4.338 2.687v27.026a3 3 0 004.338 2.685L37.799 22.67a3.008 3.008 0 000-5.372z"
          fill="#3A3A3A"
        />
      </g>
      <defs>
        <clipPath id="prefix__clip0">
          <rect width={40} height={40} rx={20} fill="#fff" />
        </clipPath>
        <filter
          id="prefix__filter0_di"
          x={4.485}
          y={2.471}
          width={36.968}
          height={37.027}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend in2="shape" result="effect2_innerShadow" />
        </filter>
      </defs>
    </svg>
  );
}

function IconAvailabilityCheck(props) {
  return (
    <svg
      width={19}
      height={18}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.303 6.397l-3.75 6a.752.752 0 01-1.167.133l-2.25-2.25a.75.75 0 011.06-1.06l1.584 1.583 3.25-5.2a.75.75 0 111.273.795zM9.667 0a9 9 0 100 18 9 9 0 000-18"
        fill="#fff"
      />
    </svg>
  );
}

function IconAvailabilityCross(props) {
  return (
    <svg
      width={18}
      height={18}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        opacity={0.4}
        d="M12.53 11.47a.75.75 0 11-1.06 1.06L9 10.06l-2.47 2.47a.75.75 0 01-1.06-1.06L7.94 9 5.47 6.53a.75.75 0 011.06-1.06L9 7.94l2.47-2.47a.75.75 0 011.06 1.06L10.06 9l2.47 2.47zM9 0a9 9 0 100 18A9 9 0 009 0z"
        fill="#CDCDCD"
      />
    </svg>
  );
}

function IconAvailabilityArrow(props) {
  return (
    <svg
      width={18}
      height={18}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.75 9.75H7.06l1.72 1.72a.75.75 0 01-1.06 1.06l-3-3a.75.75 0 010-1.06l3-3a.75.75 0 111.06 1.06L7.06 8.25h5.69a.75.75 0 110 1.5zM9 0a9 9 0 100 18A9 9 0 009 0z"
        fill="#fff"
      />
    </svg>
  );
}

function IconMassChiefs(props) {
    return (
        <img style={{width:"68px", marginTop: "5px"}} src="/masschiefs.png"/>
    )
}

export { IconMassChiefs, IconIndustryLaw, IconIndustryEMS, IconIndustryFire, IconIndustry911, IconResponseAutomate, IconResponseChat, IconResponseSurveys, IconResponseMeasure, IconLogo, IconFeatureArrow, IconFeatureCheck, IconPlay, IconAvailabilityCheck, IconAvailabilityCross, IconAvailabilityArrow }